// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__XrGgu","p":"Menu_p__3X_3_","close":"Menu_close__1Mptk","rotate":"Menu_rotate__2UAg4","logo":"Menu_logo__1y36-"};